/**
 * Factory for creating AdvancedMarkerElement markers with consistent styling
 */
export class MarkerFactory {

    /**
     * Create a region marker (white circle with label)
     * @param {google.maps.LatLng|{lat: number, lng: number}} position
     * @param {string} label - Region name
     * @param {google.maps.Map} map
     * @returns {google.maps.marker.AdvancedMarkerElement}
     */
    static createRegionMarker(position, label, map) {
        const content = this.createRegionMarkerContent(label);

        return new google.maps.marker.AdvancedMarkerElement({
            position,
            content,
            map,
            zIndex: google.maps.Marker.MAX_ZINDEX,
        });
    }

    /**
     * Create a consultant marker (small colored circle)
     * @param {google.maps.LatLng|{lat: number, lng: number}} position
     * @param {string} color - Hex color code
     * @param {google.maps.Map} map
     * @returns {google.maps.marker.AdvancedMarkerElement}
     */
    static createConsultantMarker(position, color, map) {
        const content = this.createConsultantMarkerContent(color);

        return new google.maps.marker.AdvancedMarkerElement({
            position,
            content,
            map,
            gmpClickable: true,
        });
    }

    /**
     * Create HTML content for region marker
     * Matches CSS: .region-marker in Locations.scss
     * @param {string} label
     * @returns {HTMLDivElement}
     */
    static createRegionMarkerContent(label) {
        const div = document.createElement('div');
        div.className = 'region-marker';

        const circle = document.createElement('div');
        circle.className = 'marker-circle';

        const labelDiv = document.createElement('div');
        labelDiv.className = 'marker-label';
        labelDiv.textContent = label;

        div.appendChild(circle);
        div.appendChild(labelDiv);

        return div;
    }

    /**
     * Create HTML content for consultant marker
     * Matches CSS: .consultant-marker in Locations.scss
     * @param {string} color - Hex color code
     * @returns {HTMLDivElement}
     */
    static createConsultantMarkerContent(color) {
        const div = document.createElement('div');
        div.className = 'consultant-marker';
        div.style.backgroundColor = color;

        return div;
    }

    /**
     * Create HTML content for cluster marker
     * Matches CSS: .cluster-marker in Locations.scss
     * @param {number} count - Number of markers in cluster
     * @returns {HTMLDivElement}
     */
    static createClusterMarkerContent(count) {
        const container = document.createElement('div');
        container.className = 'cluster-marker';

        // Create concentric circles
        const circles = document.createElement('div');
        circles.className = 'cluster-circles';

        for (let i = 1; i <= 3; i++) {
            const circle = document.createElement('div');
            circle.className = `circle circle-${i}`;
            circles.appendChild(circle);
        }

        // Create count label
        const countLabel = document.createElement('div');
        countLabel.className = 'cluster-count';
        countLabel.textContent = count.toString();

        container.appendChild(circles);
        container.appendChild(countLabel);

        return container;
    }

    /**
     * Scale a marker via CSS transform
     * @param {google.maps.marker.AdvancedMarkerElement} marker
     * @param {number} scale - Scale factor (1.0 = 100%)
     */
    static scaleMarker(marker, scale) {
        if (marker && marker.content) {
            marker.content.style.transform = `scale(${scale})`;
        }
    }
}
